import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { SubscriptionService } from '../../../../shared/services/subscription.service';
import { ServiceRequestService } from '../../../../services/service-request.service';
import { ServiceRequestModel } from '../../../../models/ServiceRequestModel';
import { Router } from '@angular/router';
import { Utilities } from '../../../../Utilities';
import { CustomNotification } from '../../../../CustomNotification';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../../../environments/environment';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import { SignalRService } from '../../../../services/signalr.service';
import { ClearNotificationModel } from '../../../../models/SignalrModel';
import { DxDataGridComponent } from 'devextreme-angular';
import { ServiceRequestCommentReplyModel } from '../../../../models/ServiceRequestCommentReplyModel';
@Component({
  selector: 'dashboard-service-request',
  templateUrl: './service-request.component.html',
  styleUrls: ['./service-request.component.css']
})
export class ServiceRequestComponent implements OnInit, OnDestroy {
  @ViewChild("commentGrid") commentGrid: DxDataGridComponent;
  @ViewChild("workOrderGrid") workOrderGrid: DxDataGridComponent;
  @ViewChild("DocumentGrid") DocumentGrid: DxDataGridComponent;

  @ViewChild("replyGrid") replyGrid: DxDataGridComponent;
  popupVisible = false;
  popupWorkOrderVisible = false;
  popupDocumentVisible = false;
  public CommentList: any = [];
  commentTitle = '';
  NoteSectionVisible = false;
  NotesTitle = '';
  public NoteList: any = [];
  public WorkOrderList: any = [];
  workorderTitle = '';
  CommunityLotID = 0;
  public DocumentList: any = [];
  DocumentTitle = '';
  submitted = false;
  NotePopupVisible = false;
  public apiUrl: string = environment.origin;
  // Utilities.getSecureFileUrl
  public lotId: Number = 0;
  public isWarrantyenable: boolean = true;
  public WarrantyExiprydate: any;
  public serviceRequestDataSource: any;
  public dateFormat: string = environment.serviceRequestDisplayDateFormat;

  private subscriptions: Subscription[] = [];
  public insertNotesReply: ServiceRequestCommentReplyModel = new ServiceRequestCommentReplyModel();
  constructor(public subscriptionService: SubscriptionService,
    public customNotification: CustomNotification,
    public serviceRequestService: ServiceRequestService,
    public signalRService: SignalRService,
    public router: Router) { }

  ngOnInit() {
    this.subscriptions.push(this.subscriptionService.CommunityLotId$.subscribe(lotId => {
      if (lotId) {
        this.lotId = lotId;
        this.clearAndBindGrid(lotId);
      }
    }));
    this.subscriptions.push(this.subscriptionService.IsWarrantyenable$.subscribe(isWarrantyenable => {

      this.isWarrantyenable = isWarrantyenable;


    }));
    this.subscriptions.push(this.subscriptionService.WarrantyExiprydate$.subscribe(WarrantyExiprydate => {

      this.WarrantyExiprydate = WarrantyExiprydate;


    }));
    this.subscriptions.push(this.signalRService.refreshGrids$.subscribe(x => {
      if (x) {
        this.clearAndBindGrid(this.subscriptionService.CommunityLotId$.getValue());
      }
    }));
  }

  private clearAndBindGrid(lotId: number) {
    this.bindGrid(lotId);
    let clearModel = new ClearNotificationModel();
    clearModel.CommunityLotId = lotId;
    clearModel.NotificationType = 2;
    this.signalRService.clearNotification$.next(clearModel);
  }


  private bindGrid(lotId: number) {
    this.serviceRequestDataSource = AspNetData.createStore({
      loadParams: { CommunityLotId: lotId },
      key: "ServiceRequestID",
      loadUrl: environment.origin + environment.api + "/ServiceRequest/GetServiceRequestsByCommunityLotId",
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = { Authorization: "Bearer " + localStorage.getItem(environment.token) }
        ajaxOptions.xhrFields = { withCredentials: true };
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  public onAddEditNewRequest(paramId) {
    this.serviceRequestService.resetServiceRequestWorkOrderDetails();
    this.serviceRequestService.resetAvailabilityData();
    this.router.navigate(['ServicesMaintenance/0/ServiceRequest/' + paramId]);
  }

  onUpdateSignOffandMarkasDelete(ServiceRequestID: number, Status: number) {
    this.subscriptions.push(this.subscriptionService.CommunityLotId$.subscribe(lotId => {
      if (lotId) {
        this.subscriptions.push(this.serviceRequestService.UpdateRequestStatusForSignOffandMarkasCompletefByRequestId(ServiceRequestID, Status, lotId).subscribe(x => {
          if (x) {
            this.bindGrid(this.subscriptionService.CommunityLotId$.getValue());
            this.customNotification.notify(x.Message, "", Utilities.success);
          }
        }));
      }
    }));
  }

  onDeleteServiceRequest(ServiceRequestID: number) {
    Utilities.confirm("Are you sure want to delete?", "Remove Service Request")
      .then((x) => {
        if (x) {
          this.subscriptions.push(this.serviceRequestService.DeleteServiceRequestByServiceRequestID(ServiceRequestID, this.subscriptionService.CommunityLotId$.getValue()).subscribe(x => {
            if (x) {
              this.bindGrid(this.subscriptionService.CommunityLotId$.getValue());
              this.customNotification.notify(x.Message, "", Utilities.success);
            }
          }));
        }
      });

  }
  public onTitleRendered(event: any) {
    Utilities.setTitleDxPopup(event);
  }

  public onShown(event: any) {
    if (this.commentGrid && this.commentGrid.instance) {
      this.commentGrid.instance.refresh();
    }
    if (this.replyGrid && this.replyGrid.instance) {
      this.replyGrid.instance.refresh();
    }
  }
  public onShownDocument(event: any) {
    if (this.DocumentGrid && this.DocumentGrid.instance) {
      this.DocumentGrid.instance.refresh();
    }
  }

  public onShownWorkOrderGrid(event: any) {

    if (this.workOrderGrid && this.workOrderGrid.instance) {

      this.workOrderGrid.instance.refresh();
    }
  }

  onCommentsServiceRequest(ServiceRequestID: number) {

    this.commentTitle = "Comments";
    //   this.subscriptions.push(this.subscriptionService.CommunityLotId$.subscribe(lotId => {
    //     if (lotId) {
    this.subscriptions.push(this.serviceRequestService.GetCommentsByServiceRequestID(ServiceRequestID).subscribe(x => {

      this.popupVisible = true;
      this.CommentList = [];
      if (x) {
        this.CommentList = x;
      }

    }));

    // }
    // }));

  }

  onWorkOrderServiceRequest(ServiceRequestID: number, ServiceRequestWorkOrderID: number) {

    this.workorderTitle = "Service Request Work Order";
    this.subscriptions.push(this.serviceRequestService.GetServiceRequestWorkOrdersByServiceRequestID(ServiceRequestID, ServiceRequestWorkOrderID).subscribe(x => {

      this.popupWorkOrderVisible = true;
      this.WorkOrderList = [];
      if (x) {
        this.WorkOrderList = x;
      }

    }));

  }

  onUpdateBuyerSignOff(e: any,ServiceRequestID:number, ServiceRequestWOID: number,ServiceRequestWorkorderID:number,Status:number) {
    
    this.subscriptions.push(this.serviceRequestService.UpdateBuyerSignOffData(ServiceRequestWOID,Status).subscribe(x => {
      if (x) {
        e.component.option('disabled', true);
        this.onWorkOrderServiceRequest(ServiceRequestID,ServiceRequestWorkorderID);
        this.bindGrid(Number(this.lotId));
        this.customNotification.notify(x.Message, "", x.Status ? Utilities.success : Utilities.error);
        
      }
    }));
  }
  onUpdateBuyerCompleted(e: any,ServiceRequestID:number, ServiceRequestWOID: number,ServiceRequestWorkorderID:number,Status:number) {
    
    this.subscriptions.push(this.serviceRequestService.UpdateBuyerSignOffData(ServiceRequestWOID,Status).subscribe(x => {
      if (x) {
        e.component.option('disabled', true);
              this.customNotification.notify(x.Message, "", x.Status ? Utilities.success : Utilities.error);
      }
    }));
  }
  GetPictureAndDocFiles(ServiceRequestWOID: number) {

    this.DocumentTitle = "Picture/Documents";

    this.subscriptions.push(this.serviceRequestService.GetPictureAndDocFiles(ServiceRequestWOID).subscribe(x => {

      this.popupDocumentVisible = true;
      this.DocumentList = [];
      if (x) {
        this.DocumentList = x;
      }

    }));
  }

  NotesReply(modelData: any) {
    this.NotesTitle = "Reply Note";
    this.NoteList = [];
    this.CommentList = [];
    console.log(modelData.ServiceRequestNoteID, modelData.ServiceRequestNoteID, " :ServiceRequestNoteID");
    this.NotePopupVisible = true;
    this.subscriptions.push(this.serviceRequestService.GetNotesMessageDetailsByServiceRequestNotesID(modelData.ServiceRequestNoteID).subscribe(y => {
      if (y) {
        this.NotePopupVisible = true;
        this.NoteList.messagecomment = y.data.messagecomment;
        this.NoteList.FromUser = y.data.message.LastCommentedBy;
        this.NoteList.CreatedDate = y.data.message.CreatedDateString;
        this.NoteList.ServiceRequestNoteID = modelData.ServiceRequestNoteID;
        this.NoteList.ServiceRequestID = modelData.ServiceRequestID;
        this.NoteSectionVisible = true;
        console.log(this.NoteList);
      }
      else {
        this.NoteSectionVisible = false;
        this.NoteList = [];
      }

    }));
  }

  ClosePopup() {
    this.submitted = false;
    this.NotePopupVisible = false;
    this.insertNotesReply = new ServiceRequestCommentReplyModel();
    this.onCommentsServiceRequest(this.NoteList.ServiceRequestID);
  }

  SaveNotesReply(myForm) {
    
    this.submitted = true;
    if (myForm.valid) {
      this.popupVisible = false;
      this.insertNotesReply.ServiceRequestNotesID = this.NoteList.ServiceRequestNoteID;//this.CommentList[0].ServiceRequestNoteID;
      this.insertNotesReply.Notes = (this.NoteList.Notes as string).trim();
      this.insertNotesReply.FromApplication = 'BW';
      this.subscriptions.push(this.serviceRequestService.InsertNotesReply(this.insertNotesReply).subscribe(x => {
        if (x) {
          this.submitted = false;
          this.customNotification.notify("Notes reply has been saved successfully.", "", Utilities.success);
          this.subscriptions.push(this.serviceRequestService.GetNotesMessageDetailsByServiceRequestNotesID(this.NoteList.ServiceRequestNoteID).subscribe(y => {
            if (y) {
              this.NotePopupVisible = true;
              this.NoteList.messagecomment = y.data.messagecomment;
              this.NoteList.FromUser = y.data.message.LastCommentedBy;
              this.NoteList.CreatedDate = y.data.message.CreatedDateString;
              this.NoteList.Notes = '';
              this.bindGrid(Number(this.lotId));
              // this.NotePopupVisible = false;
            }
            else {
              this.NoteList = [];
            }

          }));
        }
      }));
    }

  }
}





// WEBPACK FOOTER //
// ./src/app/modules/dashboard/service-and-maintenance/service-request/service-request.component.ts